export default __webpack_public_path__ + "images/kdei-doem-09-2023.webp";